import React from 'react';
import { AgFinancing } from '@indigo-ag/schema';
import { Body, LegalBody, palettes } from '@indigo-ag/component-module';

import { createStylesHook, utils } from 'shared';
import i18next from 'core/i18n';

interface CreditApprovalEscalatedDetailsProps {
  phase2?: AgFinancing['phase2'];
}

const useStyles = createStylesHook(theme => ({
  notesText: {
    color: `${palettes.brand.gray['700']} !important`,
    fontSize: `${theme.typography.pxToRem(13)} !important`
  }
}));

export const CreditApprovalEscalatedDetails: React.FunctionComponent<CreditApprovalEscalatedDetailsProps> = ({
  phase2
}) => {
  /**
   * Styles
   */
  const classes = useStyles();

  const escalatedBy = phase2?.escalatedBy;
  const escalatedAt = phase2?.escalatedAt;
  const escalationNotes = phase2?.escalationNotes;

  const escalationNotesTag = escalationNotes
    ? `${utils.text.toTitleCase(i18next.t('escalationNotes'))}: ${escalationNotes}. `
    : null;
  const escalationByTag = escalatedBy ? `${i18next.t('by')} ${utils.UserUtil.getUserFullName(escalatedBy)}.` : null;

  return escalatedAt ? (
    <div className="mt-3">
      <LegalBody className={classes.notesText}>{utils.date.formatDate(escalatedAt, 'L LT')}</LegalBody>
      {escalationNotes || escalatedBy ? (
        <Body className={`${classes.notesText} mt-0`}>{`${escalationNotesTag}${escalationByTag}`}</Body>
      ) : null}
    </div>
  ) : null;
};
